import { render } from "./Alert.vue?vue&type=template&id=10773597&scoped=true&ts=true"
import script from "./Alert.vue?vue&type=script&lang=ts"
export * from "./Alert.vue?vue&type=script&lang=ts"

import "./Alert.vue?vue&type=style&index=0&id=10773597&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10773597"]])

export default __exports__